import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Slider from "react-slick";
import "./styles.scss";

// Custom arrow components for square style
const CustomPrevArrow = ({ className, style, onClick, currentSlide, slideCount, slidesToShow, arrowStyle }) => {
  const isDisabled = currentSlide === 0;
  
  if (arrowStyle === "square") {
    return (
      <button 
        className={`${className} custom-arrow square-arrow ${isDisabled ? 'slick-disabled' : ''}`}
        onClick={isDisabled ? undefined : onClick}
        style={style}
        aria-label="Previous slide"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    );
  }
  
  // Default round arrow - let slick handle it with CSS
  return <div className={className} style={style} onClick={onClick} />;
};

const CustomNextArrow = ({ className, style, onClick, currentSlide, slideCount, slidesToShow, arrowStyle }) => {
  const isDisabled = currentSlide >= slideCount - slidesToShow;
  
  if (arrowStyle === "square") {
    return (
      <button 
        className={`${className} custom-arrow square-arrow ${isDisabled ? 'slick-disabled' : ''}`}
        onClick={isDisabled ? undefined : onClick}
        style={style}
        aria-label="Next slide"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    );
  }
  
  // Default round arrow - let slick handle it with CSS
  return <div className={className} style={style} onClick={onClick} />;
};

const OnePageSlider = ({
  className,
  children,
  arrowBottom = null,
  arrowTop = "50%",
  arrowLeft = "5px",
  arrowRight = "5px",
  arrowBorderColor = "transparent",
  arrowBackgroundColor = "white",
  arrowStyle = "round", // "round" or "square"
  speed = 500,
  autoplay = false,
  infinite = true,
  arrows = true,
  responsive = [],
}) => {
  // Ensure children is treated as an array to count the number of slides
  const childrenArray = Array.isArray(children) ? children : [children];
  const slideNum = childrenArray.length;

  // Dynamically set infinite and arrows based on the number of slides
  const sliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay,
    speed,
    dots: false,
    infinite: slideNum > 1 ? infinite : false, 
    arrows: slideNum > 1 ? !!arrows : false,
    prevArrow: <CustomPrevArrow arrowStyle={arrowStyle} />,
    nextArrow: <CustomNextArrow arrowStyle={arrowStyle} />,
    responsive,
    centerMode: false,
    variableWidth: false,
  };

  return (
    <div className={`onePageSlider onePageSlider--${arrowStyle} ${className || ""}`}>
      <Slider
        {...sliderSettings}
        style={{
          "--arrow-left": arrowLeft,
          "--arrow-right": arrowRight,
          "--arrow-top": arrowTop,
          "--arrow-bottom": arrowBottom,
          "--border-color": arrowBorderColor,
          "--bg-color": arrowBackgroundColor,
        }}
      >
        {children}
      </Slider>
    </div>
  );
};

export default OnePageSlider;